import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense, useCallback } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  type InsightsSearch,
  insightsSearchSchema,
} from '~/features/catalog-enrichment/utils/insight-products';

const RunInsightsPage = lazy(() => import('~/features/catalog-enrichment/pages/run-insights-page'));

/** The batch's Insights tab (was the "Content results" drill-down, finding #20). `open`/`cat`/
 *  `group` hold the one expanded row, so Back from a product or the detail view re-opens it. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights',
)({
  validateSearch: insightsSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Expanding/collapsing replaces the history entry (Back leaves the tab, not the row) and keeps
  // the scroll position where the user clicked.
  const onSearchChange = useCallback(
    (next: InsightsSearch) => {
      void navigate({ search: next, replace: true, resetScroll: false });
    },
    [navigate],
  );
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunInsightsPage runId={runId} search={search} onSearchChange={onSearchChange} />
    </Suspense>
  );
}
